import { useContext } from "react";
import { ConfigurationApiContext } from "../context/ConfigurationApiContext";
/**
 * Hook providing {@link ConfigurationApiInterface}
 * - requires {@linkcode ConfigurationController}
 * @category Hook
 * @category API
 * @export
 * @template TCsApi Specifies API type if you extended the API
 * @returns
 */
export function useConfigurationApi() {
    return useContext(ConfigurationApiContext);
}
//# sourceMappingURL=useConfigurationApi.js.map